import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.scss'
import { Helmet } from 'react-helmet'
import { getBreadcrumbsJson } from '../../../utils/json-ld'

class Page extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    titleElement: PropTypes.string,
    description: PropTypes.string,
    bgImage: PropTypes.string,
    bgColor: PropTypes.string,
    introChildren: PropTypes.object,
    breadCrumbLink: PropTypes.string,
    breadcrumbList: PropTypes.array
  }

  state = {
    promoPopupOpen: false
  }

  closePromoPopup() {
    this.setState({ promoPopupOpen: false })
  }

  render() {
    const {
      name = '',
      title = undefined,
      titleElement = 'h1',
      description = undefined,
      bgImage = undefined,
      bgColor = undefined,
      introChildren = undefined,
      breadCrumbLink = '',
      breadcrumbList = [],
      disableBreadcrumbs = false
    } = this.props

    const TitleElement = titleElement

    const style = {
      backgroundImage: bgImage ? 'url(\'' + bgImage + '\')' : '',
      backgroundColor: bgColor
    }

    return (
      <div
        className={
          'page page-' +
          name +
          (bgImage ? ' page-with-bg' : ' ') +
          (description ? '' : ' no-description')
        }
      >
        <Helmet>
          {breadcrumbList.length || name === 'main' ?
            <script type='application/ld+json'>{getBreadcrumbsJson(this.props.breadcrumbList)}</script> : ''}
        </Helmet>
        <div className='page-intro' style={style}>
          {title ? (
            <TitleElement className='page-title'>{title}</TitleElement>
          ) : null}
          {description ? (
            <p className='page-description' dangerouslySetInnerHTML={{ __html: description }} />
          ) : null}
          {introChildren ? (
            <div className='page-intro__children'>{introChildren}</div>
          ) : null}
          { !disableBreadcrumbs && (
            <div className='page__breadcrumb content-wrapper'>
              {(name && name === 'pets') || breadCrumbLink ? (
                <span>
                  <a
                    className={`${
                      name !== 'pets' ? 'page__breadcrumb-link' : ''
                    }`}
                    href='/'
                  >
                    Главная
                  </a>{' '}
                  / {breadCrumbLink}
                </span>
              ) : name === 'article' || name === 'our-article' ? (
                <span>
                  <a className='page__breadcrumb-link' href='/'>
                    Главная
                  </a>{' '}
                  / <a href={`/${name}s`}>Статьи</a> / {title}
                </span>
              ) : name !== 'feedback' && name !== 'FAQ' ? (
                <span>
                  <a className='page__breadcrumb-link' href='/'>
                    Главная
                  </a>{' '}
                  / {title}
                </span>
              ) : null}
            </div>)
          }
        </div>
        {this.props.children}
      </div>
    )
  }
}

export default Page
